import React from "react";
import { poolPrefix, not_started, status_color, std_outcome, fourone_outcome, scores_outcome } from "./liveOutcomes";

const manage_date_format = (kickoff_string) => {
  if (kickoff_string && kickoff_string.includes(" ")) {
    const regexDate = /(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2})/;
    const match = kickoff_string.match(regexDate);
    let d = new Date(match[1]);
    return d.getDate() + "/" + (d.getMonth() + 1) + " " + match[2];
  } else {
    return `${kickoff_string} `;
  }
};

// A side that won (or, for the score, a draw) is bold. Finished matches are final, matches
// in play are projected, and a match that hasn't started is grey. The key order is the
// order of the inline style, so it stays as it was.
const score_style = (match, highlighted) => {
  if (not_started(match)) {
    return { color: "silver" };
  }
  if (highlighted) {
    return { fontWeight: "bold", fontSize: "1.25em", color: status_color(match) };
  }
  return { color: match.match_status === "Finished" ? "lightslategrey" : "orange", fontSize: "1.25em" };
};

const centred = { textAlign: "center", display: "block" };

// The projection column, by Pool Type prefix. Soccer Corners and Soccer 8 show nothing,
// and Soccer 4 and Soccer 1 show nothing for a score outside their six outcomes.
const no_outcome = () => undefined;
const outcome_rules = { SS: scores_outcome, S4: fourone_outcome, S1: fourone_outcome, SC: no_outcome, S8: no_outcome };

const pick_projection = (match, venue) => {
  if (not_started(match)) {
    return <span style={centred}>?</span>;
  }
  const rule = outcome_rules[poolPrefix(venue)] ?? std_outcome;
  const value = rule(parseInt(match.home_score), parseInt(match.away_score));
  if (value === undefined) {
    return undefined;
  }
  return <span style={{ fontWeight: "bold", color: status_color(match), ...centred }}>{value}</span>;
};

const match_time = (match) => {
  switch (match.match_status) {
    case "Not Started":
    case "Postponed":
    case "Cancelled":
      return <>{manage_date_format(match.ko)}</>;
    case "Finished":
      return "FT";
    case "Abandoned":
      return "ABAN";
    case "Suspended":
      return "SUSP";
    case "Field":
      return "FIELD";
    default:
      return match.time === "HT" ? "HT" : <span className="blink">{match.time}</span>;
  }
};

const LiveMatchSummaryWide = ({ item, pool_title }) => {
  const backgroundColor = item.mnum % 2 === 0 ? "#fafafa" : "#f2f2f2";
  const home = parseInt(item.home_score);
  const away = parseInt(item.away_score);
  // Soccer 8 HF: odd matches are half-time results, even matches full-time results.
  const soccer8 = poolPrefix(pool_title) === "S8";
  const half_time = parseInt(item.mnum) % 2;
  const match_suffix = half_time ? ["H"] : ["F"];
  const team_suffix = half_time ? [" (Half Time)"] : [" (Full Time)"];
  return (
    <>
      <tr>
        <td style={{ width: "3%", fontWeight: "bold", padding: "1px", backgroundColor }}>
          {"M" + item.mnum}
          {soccer8 ? match_suffix : null}
        </td>
        <td style={{ width: "8%", fontWeight: "bold", padding: "1px", backgroundColor }}>
          <center>
            {match_time(item)}
            <br />
          </center>
        </td>
        <td style={{ width: "3%", padding: "1px", backgroundColor }}>{pick_projection(item, pool_title)}</td>
        <td style={{ width: "37%", maxWidth: "36%", overflow: "hidden", padding: "1px", backgroundColor }} rowSpan={2}>
          <span style={score_style(item, home > away)}>
            {item.teamA}
            {soccer8 ? team_suffix : null}
          </span>
        </td>
        <td style={{ width: "12%", textAlign: "center", backgroundColor }} rowSpan={2}>
          <span style={{ ...score_style(item, home === away), ...centred }}>{not_started(item) ? "" : item.home_score + " - " + item.away_score}</span>
        </td>
        <td style={{ width: "37%", maxWidth: "36%", overflow: "hidden", padding: "1px", textAlign: "right", backgroundColor }} rowSpan={2}>
          <span style={score_style(item, home < away)}>
            {item.teamB}
            {soccer8 ? team_suffix : null} <br />
          </span>
        </td>
      </tr>
      <tr>
        <td className="hide-for-small" colSpan={3} style={{ fontSize: "0.65em", padding: "1px", textAlign: "center", backgroundColor }}>
          {item.comp_name}
        </td>
      </tr>
    </>
  );
};

export default LiveMatchSummaryWide;
